import format from "date-fns-tz/format";
import enGB from "date-fns/locale/en-GB";

export default function readAbbreviatedTimeZone(): string {
  return format(new Date(), "zzz", {
    locale: enGB,
  });
}
